import { MARQUEE_ITEMS } from "../data/content";

const Star = () => (
    <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        className="w-4 h-4 shrink-0 text-bh-gold"
        fill="currentColor"
    >
        <path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" />
    </svg>
);

export const Marquee = () => {
    const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
    return (
        <div
            data-testid="editorial-marquee"
            className="bg-bh-deep py-5 overflow-hidden"
            aria-label="30 Juz, Mutqin, Bersanad, Tahsin, Tahfidz, Sanad Al-Qur'an, Adab Qurani"
        >
            <div className="marquee-track flex items-center gap-10 w-max">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center gap-10" aria-hidden={half === 1}>
                        {row.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center gap-10">
                                <span className="font-serif text-lg sm:text-xl tracking-[0.18em] uppercase text-white/90 whitespace-nowrap">
                                    {item}
                                </span>
                                <Star />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};
